import { render, staticRenderFns } from "./BrandTable.vue?vue&type=template&id=193ed8ce"
import script from "./BrandTable.vue?vue&type=script&lang=js"
export * from "./BrandTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports